import { apiService } from './api';
import { Sale, ApiResponse } from '../types';

export const saleService = {
  async getSales(
    page: number = 1,
    perPage: number = 20,
    filters?: {
      item_id?: number;
      category?: string;
      start_date?: string;
      end_date?: string;
      min_amount?: number;
      max_amount?: number;
      sort_by?: 'date' | 'amount' | 'quantity' | 'profit';
      sort_order?: 'asc' | 'desc';
    }
  ): Promise<ApiResponse<{ sales: Sale[]; pagination: any }>> {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });
    if (filters?.item_id) {
      params.append('item_id', filters.item_id.toString());
    }
    if (filters?.category) {
      params.append('category', filters.category);
    }
    if (filters?.start_date) {
      params.append('start_date', filters.start_date);
    }
    if (filters?.end_date) {
      params.append('end_date', filters.end_date);
    }
    if (filters?.min_amount !== undefined) {
      params.append('min_amount', filters.min_amount.toString());
    }
    if (filters?.max_amount !== undefined) {
      params.append('max_amount', filters.max_amount.toString());
    }
    if (filters?.sort_by) {
      params.append('sort_by', filters.sort_by);
    }
    if (filters?.sort_order) {
      params.append('sort_order', filters.sort_order);
    }
    return apiService.get(`/api/sales?${params.toString()}`);
  },

  async getSale(id: number): Promise<ApiResponse<Sale>> {
    return apiService.get(`/api/sales/${id}`);
  },

  async createSale(data: {
    item_id: number;
    quantity_sold: number;
    selling_price?: number;
    date: string;
  }): Promise<ApiResponse<Sale>> {
    return apiService.post('/api/sales', data);
  },

  async updateSale(
    id: number,
    data: {
      quantity_sold?: number;
      selling_price?: number;
      date?: string;
    }
  ): Promise<ApiResponse<Sale>> {
    return apiService.put(`/api/sales/${id}`, data);
  },

  async deleteSale(id: number): Promise<ApiResponse> {
    return apiService.delete(`/api/sales/${id}`);
  },

  async getTodaySales(): Promise<ApiResponse<{ sales: Sale[]; summary: any }>> {
    return apiService.get('/api/sales/today');
  },

  async getMonthlySales(month?: string): Promise<ApiResponse<{ sales: Sale[]; summary: any }>> {
    const params = month ? `?month=${month}` : '';
    return apiService.get(`/api/sales/monthly${params}`);
  },

  async getYearlySales(year?: number): Promise<ApiResponse<{ sales: Sale[]; summary: any }>> {
    const params = year ? `?year=${year}` : '';
    return apiService.get(`/api/sales/yearly${params}`);
  },
};

